import { Component, Input } from '@angular/core';

import { CropFieldLegalStandardData } from '../../fertilization-legal-standards.models';

@Component({
  selector: 'app-crop-field-legal-standards',
  templateUrl: './crop-field-legal-standards.component.html',
  styleUrls: ['./crop-field-legal-standards.component.scss'],
  standalone: false,
})
export class CropFieldLegalStandardsComponent {
  @Input() title: string;
  @Input() cropFields: CropFieldLegalStandardData[];

  constructor() {}

  getGrasslandUsageTranslationKey(grasslandUsage: string | number | null): string | null {
    if (typeof grasslandUsage === 'string') {
      return grasslandUsage.toLowerCase();
    }

    switch (grasslandUsage) {
      case 0:
        return 'mow';
      case 1:
        return 'graze';
      default:
        return null;
    }
  }
}
